module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAVZJREFUOE/dlLFLQlEYxc95z5agKfoHoiGiqb21La+0NUlbe/ieQYNQlD0pCKGmwMaC7KlRa0sY9RfUVBRCBA2hkWn3C5TC0odp5tDd7r3f/XHOved+RIcHO8xD94ESsBcgEqk6YRFiDjK9fO/lrE6hBEIT0Bz4PGDCB7C/MheUoOXxC8wwTulGrz/W6oHK3gFkGkAW4IvnHQuGqnsSYtpJegIrJcouoFQe4dHajRdQlOWAFLqrdm1Nw0f5U6AoawZaHpiJHYoKb8DUMSadu7YVirK2QOToOosSsK5AM8iDlex/BvrtTUDnmI4tibIvoSXIjHPWvuXJuWEYUmBq/VbU/Dhe8+c8jhdbA/qtPAxjtPYHfM9jBQhoppzwD3JoXQDcR0kn4OuR+nDrPkDvwjDidKOJ5sCp0BjeuA3BKNiwIz1DsIen3lmeRMpNgb/pkd3vh62qfQdcBOQV03AJ2gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/set_icon_delete_s.png
// module id = aTo5
// module chunks = 0